var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-6 pb-2 pt-6" },
    [
      _c(
        "vs-button",
        {
          staticClass: "w-full",
          on: {
            click: function ($event) {
              _vm.activePrompt = true
            },
          },
        },
        [_vm._v("Add Task")]
      ),
      _c(
        "vs-prompt",
        {
          attrs: {
            "vs-title": "Add Task",
            "vs-accept-text": "Add Task",
            "vs-button-cancel": "border",
            "vs-is-valid": _vm.validateForm,
            "vs-active": _vm.activePrompt,
          },
          on: {
            "vs-cancel": _vm.clearFields,
            "vs-accept": _vm.submitTodo,
            "vs-close": _vm.clearFields,
            "update:vsActive": function ($event) {
              _vm.activePrompt = $event
            },
            "update:vs-active": function ($event) {
              _vm.activePrompt = $event
            },
          },
        },
        [
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col ml-auto flex" },
                  [
                    _c("feather-icon", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        icon: "InfoIcon",
                        svgClasses: [
                          { "text-success stroke-current": _vm.isImportant },
                          "w-5",
                          "h-5 mr-4",
                        ],
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.isImportant = !_vm.isImportant
                        },
                      },
                    }),
                    _c("feather-icon", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        icon: "StarIcon",
                        svgClasses: [
                          { "text-warning stroke-current": _vm.isStarred },
                          "w-5",
                          "h-5 mr-4",
                        ],
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.isStarred = !_vm.isStarred
                        },
                      },
                    }),
                    _c(
                      "vs-dropdown",
                      {
                        staticClass: "cursor-pointer",
                        attrs: { "vs-custom-content": "" },
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "TagIcon", svgClasses: "h-5 w-5" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        }),
                        _c(
                          "vs-dropdown-menu",
                          { staticStyle: { "z-index": "200001" } },
                          _vm._l(_vm.todoTags, function (tag, index) {
                            return _c(
                              "vs-dropdown-item",
                              { key: index },
                              [
                                _c(
                                  "vs-checkbox",
                                  {
                                    attrs: { "vs-value": tag.value },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                    model: {
                                      value: _vm.tags,
                                      callback: function ($$v) {
                                        _vm.tags = $$v
                                      },
                                      expression: "tags",
                                    },
                                  },
                                  [_vm._v(_vm._s(tag.text))]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "w-full mb-4 mt-5",
                      attrs: {
                        name: "title",
                        placeholder: "Title",
                        color: _vm.validateForm ? "success" : "danger",
                      },
                      model: {
                        value: _vm.title,
                        callback: function ($$v) {
                          _vm.title = $$v
                        },
                        expression: "title",
                      },
                    }),
                    _c("vs-textarea", {
                      attrs: { rows: "5", label: "Add description" },
                      model: {
                        value: _vm.desc,
                        callback: function ($$v) {
                          _vm.desc = $$v
                        },
                        expression: "desc",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }